<circ-loader [isLoading]="loading">
</circ-loader>
<circ-form-basic
    *ngIf="!loading"
    [circulation]="circulation"
    (save)="onSave($event)"
    (abort)="onAbort()"
    (error)="onError($event)"></circ-form-basic>
